export const cancellationReasons = [
  {
    code: "PR_CUSTOMER_BOUGHT_OTHER_FORD_VEHICLE",
    displayText: "Customer bought other Ford vehicle",
  },
  {
    code: "PR_CUSTOMER_MOVED",
    displayText: "Customer moved",
  },
  {
    code: "PR_CUSTOMER_BOUGHT_VEHICLE_FROM_OTHER_BRAND",
    displayText: "Customer bought vehicle from other brand",
  },
  {
    code: "PR_CUSTOMER_DECIDED_NOT_TO_PURCHASE",
    displayText: "Customer decided not to purchase",
  },
  {
    code: "PR_VEHICLE_NO_LONGER_AVAILABLE",
    displayText: "Vehicle no longer available",
  },
  {
    code: "PR_UNRESPONSIVE_CUSTOMER",
    displayText: "Unresponsive customer",
  },
  {
    code: "PR_OTHER",
    displayText: "Other",
  },
];

export const PR_OTHER_CODE = "PR_OTHER";

const OTHER_REASON_PATTERN = new RegExp(`^${PR_OTHER_CODE}: '(.*)'$`, "s");

// Nukleus expects the reason key; "Other" appends the dealer's text after it
export const buildPurchaseRequestRejectedReason = (
  displayText,
  otherText = ""
) => {
  const reason = cancellationReasons.find(
    (item) => item.displayText === displayText
  );

  if (!reason) {
    throw new Error(`Unknown cancellation reason: ${displayText}`);
  }

  return reason.code === PR_OTHER_CODE
    ? `${PR_OTHER_CODE}: '${otherText.trim()}'`
    : reason.code;
};

// Older orders stored the display text itself, so unknown values pass through
export const getPurchaseRequestReasonLabel = (value) => {
  if (typeof value !== "string") {
    return value;
  }

  const otherMatch = OTHER_REASON_PATTERN.exec(value);
  if (otherMatch) {
    return otherMatch[1];
  }

  const reason = cancellationReasons.find((item) => item.code === value);
  return reason ? reason.displayText : value;
};
